import type { QuoteStatus } from "@/types";
import { colors, semanticColors, radius, heights, spacing, typography } from "@/styles/tokens";

type PillStyle = { bg: string; fg: string; border: string };

const styles: Record<QuoteStatus, PillStyle> = {
  Draft:   { bg: colors.gray100,  fg: colors.gray600, border: colors.gray200 },
  Finalised: { bg: colors.white,  fg: semanticColors.accentTextOnTint, border: colors.indigo100 },
  // quote-won-lost: a finalised quote with no outcome yet -- same look as
  // Finalised, which is what it is.
  Open:    { bg: colors.white,    fg: semanticColors.accentTextOnTint, border: colors.indigo100 },
  Sent:    { bg: colors.indigo50, fg: semanticColors.accentTextOnTint, border: colors.indigo100 },
  Won:     { bg: colors.green50,  fg: colors.green600, border: colors.green100 },
  Lost:    { bg: colors.white,    fg: colors.gray600, border: colors.gray400 },
  Expired: { bg: colors.amber50,  fg: colors.amber600, border: colors.amber200 },
  // quote-revisions: replaced by its revision -- neutral, it is history.
  Superseded: { bg: colors.gray100, fg: colors.gray600, border: colors.gray200 },
};

export function StatusPill({ status }: { status: QuoteStatus }) {
  const s = styles[status];
  return (
    <span
      data-testid={`status-pill-${status.toLowerCase()}`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        height: heights.pill,
        padding: `0 ${spacing[8]}px`,
        borderRadius: radius.base,
        fontSize: typography.fontSize.sm,
        lineHeight: typography.lineHeight.tight,
        color: s.fg,
        backgroundColor: s.bg,
        border: `1px solid ${s.border}`,
        fontWeight: typography.fontWeight.medium,
      }}
    >
      {status}
    </span>
  );
}
